import AdminModalNew from "./AdminModalNew";
import { CheckRoundedIcon } from "../../icons";

/**
 * The admin dashboard's "that worked" dialog — the counterpart to ConfirmationModal.
 *
 * The global alert bar cannot do this job on the screens that confirm before writing:
 * it is raised behind the open dialog, and it is gone a few seconds later. A change the
 * admin had to deliberately confirm deserves an equally deliberate acknowledgement,
 * one that stays up and can name exactly what was written (pass it as `children`).
 */
const SuccessModal = ({
    show,
    title = "Saved",
    description,
    children,
    closeLabel = "Done",
    size = "modal-md",
    onClose,
}) => {
    if (!show) return null;

    return (
        <AdminModalNew show={show} size={size} centered onClose={onClose}>
            <div className="tw:!flex tw:!justify-center tw:!mb-4">
                <CheckRoundedIcon size={56} />
            </div>

            <h5 className="tw:!text-center tw:!text-[20px] tw:!font-[600] tw:!text-[#4E4E4E] tw:!mb-2">
                {title}
            </h5>

            {description && (
                <p className="tw:!text-center tw:!text-[14px] tw:!text-[#8D8D8D] tw:!mb-6">
                    {description}
                </p>
            )}

            {children ? <div className="tw:mb-8">{children}</div> : null}

            <div className="tw:!flex tw:!justify-center">
                <button
                    type="button"
                    onClick={onClose}
                    className="tw:!py-3 tw:!px-12 tw:!rounded-md tw:!font-[400] tw:!text-[15px] tw:!cursor-pointer tw:!bg-[#3CAEA3] tw:!text-white"
                >
                    {closeLabel}
                </button>
            </div>
        </AdminModalNew>
    );
};

export default SuccessModal;
